import router from './router'
import store from './store'
import utils from './utils/utils'
import secret from './utils/secret'
import { setToken, getToken, getUserToken } from '@/utils/cookies'
import { removeLocalOrderProsData } from '@/utils/storage'
import { GetUserInfo } from './store/modules/user'
import axios from "axios"
import { remove } from 'js-cookie'


// 不需要删除缓存的路由
const unWantedRemoveLocalData = {
  account: '/account'
}


const CITY_PLATFORM_PATH = process.env.CITY_PLATFORM_PATH
const SSO_WEB_URL = process.env.SSO_WEB_URL
// const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH


router.beforeEach((to, from, next) => {
  console.log("jzgw_to",to)
  console.log("jzgw_from",from)
    const toPath = to.path // 跳转路由
    const toMeta = to.meta // 跳转路由信息
    let requireAuth = toMeta.requireAuth // 是否需要登录
    let jumpAuth = toMeta.jumpAuth // 是否个人中心跳转
    const isLogin = store.getters.isLogin
    const token = getUserToken() // 游客token
    const userToken = getUserToken() // 登录用户token
    let existToken = utils.isNotEmpty(token) // 存在游客token
    
    // 导航栏选中
    // ------------------ 处理重定向路径-start
    let targetUrl = SSO_WEB_URL + toPath
  
    let existUserToken  ;
    // ==========================出路支付成功携带状态过去
    let paramsStr =''
    // if(to.query.payPlat === 'jgsgw'){
    //   let newParamsObj = {
    //     price: to.query.price,
    //     orderNos: to.query.orderNos,
    //     payPlat: to.query.payPlat,
    //   }
    //   Object.entries(newParamsObj).forEach(value => {
    //     paramsStr+=`&${value[0]}=${value[1]}`
    //   })
    // }
    console.log("CITY_PLATFORM_PATH",CITY_PLATFORM_PATH + from.fullPath)
    let paramsRedirectUrl = 'redirectUrl=' + secret.encryptionText(CITY_PLATFORM_PATH + from.fullPath) + paramsStr
    // let paramsRedirectUrl = 'redirectUrl=' + (CITY_PLATFORM_PATH + from.fullPath) + paramsStr
    let params = '?' + paramsRedirectUrl// 回调路径参数
    let targetFullUrl = (isLogin && jumpAuth) ? targetUrl : targetUrl + params
    // let targetFullUrl = isLogin? targetUrl : targetUrl + params
    console.log("taFUrl",targetFullUrl)
    console.log("requireAuth",requireAuth)
    console.log("existToken", existToken)
    // ------------------ 处理重定向路径-end
    if(to.path =='/login'){
      window.location.href = targetFullUrl
    }

    // 登录成功以后会跳参数
    let currentUrl = window.location.href
    if (currentUrl.indexOf('loginToken=') !== -1) {
      let loginToken =  currentUrl.substr(currentUrl.lastIndexOf('loginToken=') + "loginToken=".length)
      console.log("jzgw_loginToken222", loginToken)
      console.log("cookie111",document.cookie)   //us-key=8335e129ea0d0b232a402c2f1154ef3c

      let jzgwCookie = document.cookie = "us-key=" + loginToken.split("; ") //覆盖cookies里的token
      let newToken = JSON.parse(JSON.stringify(jzgwCookie).replace("us-key=","")) //新token
      console.log("cookie222", newToken) 
      setToken (newToken)

      store.dispatch('GetUserInfo').then(res => {
        let errorInfo = res.data.errorInfo
        console.log("获取用户登录信息sss", res.data.errorInfo)
        window.location.href = process.env.CITY_PLATFORM_PATH + window.location.pathname
        if(errorInfo=="success"){
          commit('SET_ISLOGIN', true)
          console.log("获取用户登录biubiu",  res.data.data)
          next()
        }
      })
      next()
    }

    if (existToken) { // 存在游客token
      console.log("targetFullUrl",targetFullUrl);
      store.dispatch('GetUserInfo').then(res => {
      existUserToken =  res.data; // 存在登录用户token
     
        if (existUserToken) { // 存在登录token
          console.log("存在登录token");
          if (jumpAuth) {
            console.log("jumpAuth错误");
            window.location.href = targetFullUrl
          } else {
            console.log("jumpAuth正确");
            store.dispatch('GetUserInfo').then(res => {
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          console.log("不存在登录token");
          window.location.href = targetFullUrl
        }
      })
      
      if (requireAuth) {
        window.location.href = targetFullUrl
      } else {
        if (existUserToken) {
           // 存在登录token
          if (jumpAuth) {
            window.location.href = targetFullUrl
          } else {
            store.dispatch('GetUserInfo').then(res => {
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          next()
        }
      }
    } else { // 获取游客token
      store.dispatch('findToken').then(res => {
        next()
      })
    }
    // ------------------ 处理登录数据信息 - end
})


router.beforeResolve((to, from, next) => {
  next()
})

/** 路由离开 */
router.afterEach((to, from) => {
  if (to.path !== unWantedRemoveLocalData.account) {
    removeLocalOrderProsData()
  }
})


// WEBPACK FOOTER //
// ./src/permission.js